module.exports = __webpack_public_path__ + "static/media/fengpai.43bc3476.png";